module.exports = __webpack_public_path__ + "static/media/sanecum-logo.c605fcbb.png";